


import {
  Component,
  Prop,
  Vue,
  Watch,
  Mixins,
  Emit
} from "vue-property-decorator";
import Chart from "chart.js";
import VueChart from "vue-chartjs";



@Component
export default class LineChart extends Mixins(VueChart.Line, VueChart.mixins.reactiveProp) {
  /**
   * Chart data
   */
  @Prop({ required: true, default: {} })
  public chartData!: Chart.ChartData;

  /**
   * Chart options(If override default options)
   */
  @Prop()
  public chartOptions!: Chart.ChartOptions;
  /**
   * Chart options
   */
  private options: Chart.ChartOptions = {};

  /**
   * Chart style options
   */
  @Prop()
  public styleOptions!: object;

  /**
   * Chart instance
   */
  private chart!: Chart;

  mounted() {
    this.renderChart(this.chartData, this.chartOptions || this.options);
  }
}
